// extracted by mini-css-extract-plugin
export var formContainer = "_e2-0";
export var message = "_e2-1";